import { render, staticRenderFns } from "./PageCanteen.vue?vue&type=template&id=c79bb038&"
import script from "./PageCanteen.vue?vue&type=script&lang=js&"
export * from "./PageCanteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports